import type { GlobalSearchHit } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import { getContext } from './core';

export const searchApi = {
  global: async (q: string): Promise<GlobalSearchHit[]> => {
    const context = getContext();
    const enc = encodeURIComponent(q);
    return router.get<GlobalSearchHit[]>(`/search?q=${enc}`, context);
  },
};
